import { isEmpty } from 'lodash';

/**
 * Checks if the fetch response is OK.
 *
 * @param {object} response - The response object.
 * @returns {Promise<object>} The response body in json format.
 * @throws {Error} Error if response is not ok.
 */
export const isResponseOK = response => {
  if (response.ok) return response.json();
  console.error(response);
  throw new Error('Network response was not ok. Server Error');
};

/**
 * Checks if the http call result is OK.
 *
 * @param {object} result - The response object.
 * @returns {Promise<object>|object} The response body in json format.
 * @throws {Error} Error if response is not ok.
 */
export const isHTTPResultOK = result => {
  if (result.statusCode === 200) {
    if (!isEmpty(result.content)) return JSON.parse(result.content);
    if (!isEmpty(result.data)) return result.data;
  }
  console.error(result);
  throw new Error('Network response was not ok. Server Error');
};
